import { render, staticRenderFns } from "./ContentPackDetails.vue?vue&type=template&id=712bf316&"
import script from "./ContentPackDetails.vue?vue&type=script&lang=js&"
export * from "./ContentPackDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports